import React from 'react';
import ToggleSwitch from './ToggleSwitch';

export default function Toggle({
  id,
  checked,
  onChange,
  label,
  className,
  labelClassName,
  showStatus = false
}: {
  id: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  className?: string;
  labelClassName?: string;
  showStatus?: boolean;
}) {
  return (
    <div className={ className }>
      <ToggleSwitch id={ id } checked={ checked } onChange={ onChange } showStatus={ showStatus } />
      <label htmlFor={ id } className={ labelClassName }>
        { label }
      </label>
    </div>
  );
}

